import React from "react";
import { TermsEn } from "../../components/Terms/TermsEn";
import { TermsHe } from "../../components/Terms/TermsHe";
import { useTranslation } from "react-i18next";

const normalize = (lang?: string) => {
  if (!lang) return null;

  const v = lang.toLowerCase();

  const mapping: Record<string, "en" | "he"> = {
    en: "en",
    he: "he",
  };

  return mapping[v] ?? null;
};

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  const lang = t("graphql.languageCode");
  const resolved = normalize(lang);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!resolved) {
    return <TermsEn />;
  }

  return resolved === "en" ? <TermsEn /> : <TermsHe />;
};

export default TermsPage;
